/**
 * @generated SignedSource<<858910b3bdc5ec34dac322a7c4ca1f46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCardRestoreRequestMutation$variables = {
  id: string;
};
export type FeedbackCardRestoreRequestMutation$data = {
  readonly restoreRequest: {
    readonly feedbackAndRequestsEdge: {
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardRequest">;
      };
    };
  } | null;
};
export type FeedbackCardRestoreRequestMutation = {
  response: FeedbackCardRestoreRequestMutation$data;
  variables: FeedbackCardRestoreRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = [
  (v3/*: any*/)
],
v11 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenByUser",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCardRestoreRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RestoreRequest",
        "kind": "LinkedField",
        "name": "restoreRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FeedbackCardRequest"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCardRestoreRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RestoreRequest",
        "kind": "LinkedField",
        "name": "restoreRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackAndRequestsEdge",
            "kind": "LinkedField",
            "name": "feedbackAndRequestsEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cancelledByCreator",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedbackRecordNode",
                        "kind": "LinkedField",
                        "name": "feedbackRecord",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contents",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedbackNode",
                        "kind": "LinkedField",
                        "name": "feedback",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isAnonymous",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDraft",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sharedWithMe",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeedbackRecipientNode",
                            "kind": "LinkedField",
                            "name": "recipients",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shared",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "context",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isGuest",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "relationshipToViewer",
                                    "storageKey": null
                                  }
                                ],
                                "type": "User",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "start",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "end",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Event",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventStart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventEnd",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Note",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "emoji",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "type": "OtherContext",
                                "abstractKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMeetingFeedback",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "requestCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updatedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isThreeSixtyParent",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasDraftResponse",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cancelledByUser",
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "type": "FeedbackRequestNode",
                    "abstractKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b5c5630495827e983e015c53642aae41",
    "id": null,
    "metadata": {},
    "name": "FeedbackCardRestoreRequestMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackCardRestoreRequestMutation(\n  $id: ID!\n) {\n  restoreRequest(id: $id) {\n    feedbackAndRequestsEdge {\n      node {\n        __typename\n        ...FeedbackCardRequest\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FeedbackCardFeedback on FeedbackNode {\n  ...FeedbackSubject_item\n  id\n  title\n  type\n  isArchived\n  isDraft\n  lastSeenByUser\n  isMeetingFeedback\n  requestCount\n  responseCount\n  sharedWithMe\n  updatedAt\n  isThreeSixtyParent\n  isAnonymous\n  creator {\n    id\n    email\n    image\n    fullName\n    firstName\n    lastName\n  }\n  recipients {\n    shared\n    user {\n      id\n    }\n    id\n  }\n}\n\nfragment FeedbackCardRequest on FeedbackRequestNode {\n  ...FeedbackSubjectRequest_item\n  id\n  hasDraftResponse\n  isArchived\n  cancelledByUser\n  cancelledByCreator\n  lastSeenByUser\n  feedbackRecord {\n    id\n  }\n  feedback {\n    ...FeedbackCardFeedback\n    id\n  }\n}\n\nfragment FeedbackSubjectRequest_item on FeedbackRequestNode {\n  id\n  cancelledByCreator\n  feedbackRecord {\n    contents\n    id\n  }\n  feedback {\n    isAnonymous\n    id\n    type\n    title\n    isDraft\n    sharedWithMe\n    creator {\n      id\n      email\n      image\n      fullName\n      firstName\n      lastName\n    }\n    recipients {\n      user {\n        id\n      }\n      id\n    }\n    context {\n      __typename\n      ... on User {\n        id\n        email\n        image\n        fullName\n        firstName\n        lastName\n        isGuest\n        relationshipToViewer\n      }\n      ... on Event {\n        id\n        title\n        start\n        end\n      }\n      ... on Note {\n        id\n        title\n        eventStart\n        eventEnd\n        url\n      }\n      ... on OtherContext {\n        name\n        emoji\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment FeedbackSubject_item on FeedbackNode {\n  id\n  type\n  title\n  isDraft\n  sharedWithMe\n  isAnonymous\n  creator {\n    id\n    email\n    image\n    fullName\n    firstName\n    lastName\n  }\n  recipients {\n    user {\n      id\n    }\n    id\n  }\n  context {\n    __typename\n    ... on User {\n      id\n      email\n      image\n      fullName\n      firstName\n      lastName\n      isGuest\n      relationshipToViewer\n    }\n    ... on Event {\n      id\n      title\n      start\n      end\n    }\n    ... on Note {\n      id\n      title\n      eventStart\n      eventEnd\n      url\n    }\n    ... on OtherContext {\n      name\n      emoji\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6bb7a02804f3f7ab42a5e1db8d741f4";

export default node;
